export default __webpack_public_path__ + "static/bz-4be3cfe9a16b43f14757e6c19d474d63.svg";